import { useEffect } from 'react';

import { gameDayLinks } from '@/modules/league/new-components/constants';
import { useLoader } from '@/modules/league/PickleballLoaderContext';
import { useRouter, useSearchParams } from 'next/navigation';

// For getting correct css types of links in navigation
export const getLinkClass = (type: string, isMobile: boolean, pageType: string | undefined) => {
  const baseClass = `flex-1 border-b-[5px] px-5 py-3 ${isMobile ? 'md:text-center' : ''}`;
  const activeClass =
    pageType === type
      ? 'border-leagues-500 text-leagues-500'
      : 'text-gray-500 hover:border-leagues-300/50 hover:text-leagues-300';
  const alignmentClass =
    type === 'rsvp' ? 'text-left' : type === 'groups' ? 'text-center' : 'text-right';
  return `${baseClass} ${activeClass} ${alignmentClass}`;
};

// For rendering links in navigation
export const NavLinkMobile = ({
  isMobile,
  pageType,
  isRatingLeagueShowStats,
  sequenceNumber,
}: {
  isMobile: boolean;
  pageType: string | undefined;
  isRatingLeagueShowStats: boolean;
  sequenceNumber: string | null;
}) => {
  const { setLoading } = useLoader();
  const searchParams = useSearchParams();
  const router = useRouter();
  useEffect(() => {
    setLoading(false);
  }, [pageType]);

  const handleClick = (type: string) => {
    if (pageType !== type) {
      setLoading(true);
      const newSearchParams = new URLSearchParams(searchParams || '');
      newSearchParams.set('tab', type);
      router.replace(`?${newSearchParams.toString()}`, { scroll: false });
      if (sequenceNumber && type !== 'rsvp') {
        newSearchParams.set('sequenceNumber', sequenceNumber);
        router.replace(`?${newSearchParams.toString()}`, { scroll: false });
      }
    }
  };

  return gameDayLinks.map((link) => (
    <button
      key={link.type}
      className={getLinkClass(link.type, isMobile, pageType)}
      onClick={() => handleClick(link.type)}
    >
      {link.label === 'Groups' && isRatingLeagueShowStats ? 'Stats' : link.label}
    </button>
  ));
};
